import React from 'react'
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, LabelList } from 'recharts'

const Chart = ({ chartData }) => {
    const barColors = [
        '#EF8080',
        '#EF8080',
        '#EF8080',
        '#EF8080',
        '#EF8080',
        '#EF8080',
        '#EF8080',
        '#F3E97A',
        '#F3E97A',
        '#8CD991',
        '#8CD991',
    ]

    const renderLabel = props => {
        const { x, y, width, value } = props
        return (
            <text x={x + width / 2} y={y - 5} fill="#373539" textAnchor="middle" fontWeight="bold">
                {value}
            </text>
        )
    }

    return (
        <BarChart width={600} height={340} data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid vertical={false} strokeDasharray="none" stroke="#CACACA" />
            <XAxis dataKey="name" tick={{ fill: '#373539', fontSize: '13px' }} />
            <YAxis
                tickCount={7}
                domain={[0, 'dataMax + 50']}
                tick={{ fill: '#373539', fontSize: '13px' }}
                axisLine={false}
                tickLine={false}
                tickMargin={10}
            />
            <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                <LabelList dataKey="value" content={renderLabel} />
                {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={barColors[index % barColors.length]} />
                ))}
            </Bar>
        </BarChart>
    )
}

export default Chart
